function __$styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

import { createElement, PureComponent } from 'react';
import styled, { keyframes, css } from 'styled-components';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
}

var spin = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  to {\n    transform: rotate(1turn);\n  }\n"], ["\n  to {\n    transform: rotate(1turn);\n  }\n"])));
var spinParams = '22s linear infinite';
var Shape = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  transition: border-radius 1s ease-out;\n  transform-origin: center;\n  overflow: hidden;\n  ", "\n  ", "\n"], ["\n  transition: border-radius 1s ease-out;\n  transform-origin: center;\n  overflow: hidden;\n  ", "\n  ", "\n"])), function (props) {
  return props.size && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n  "], ["\n    width: ", ";\n    height: ", ";\n  "])), props.size, props.size);
}, function (props) {
  return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    border-radius: ", ";\n    animation: ", " ", "s ease-in-out infinite both alternate,\n  ", " ", ";\n  "], ["\n    border-radius: ", ";\n    animation: ", " ", "s ease-in-out infinite both alternate,\n  ", " ", ";\n  "])), props.radius1, keyframes(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      0% {\n        border-radius: ", ";\n      }\n      100% {\n        border-radius: ", ";\n      }\n    "], ["\n      0% {\n        border-radius: ", ";\n      }\n      100% {\n        border-radius: ", ";\n      }\n    "])), props.radius1, props.radius2), Math.random() * 10 | 0 + 10, spin, spinParams);
});
var ShapeContent = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  animation: ", " ", " reverse;\n  transform-origin: center;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  animation: ", " ", " reverse;\n  transform-origin: center;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), spin, spinParams);
var Image = styled.img(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  transform: scale(1.25);\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"], ["\n  transform: scale(1.25);\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"])));

var randomRadiuses = function randomRadiuses(x) {
  return new Array(x).fill(1).map(function () {
    return radiuses[Math.random() * radiuses.length | 0];
  }).join(' ');
};

var radiuses = ['70%', '60%', '50%', '40%', '55%', '45%'];

var makeRadius1 = function makeRadius1() {
  return randomRadiuses(4) + ' / ' + randomRadiuses(4);
};

var makeRadius2 = function makeRadius2() {
  return randomRadiuses(2);
};

var Blob =
/** @class */
function (_super) {
  __extends(Blob, _super);

  function Blob() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Blob.prototype.render = function () {
    var _a = this.props,
        src = _a.src,
        children = _a.children,
        size = _a.size,
        props = __rest(_a, ["src", "children", "size"]);

    var radius1 = makeRadius1();
    var radius2 = makeRadius2();
    return createElement(Shape, _assign({
      size: size,
      radius1: radius1,
      radius2: radius2
    }, props), createElement(ShapeContent, null, src ? createElement(Image, {
      src: src
    }) : children));
  };

  return Blob;
}(PureComponent);

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
export { Blob };